import { faPencil, faTrash } from '@fortawesome/pro-light-svg-icons';
import { faBell } from '@fortawesome/pro-regular-svg-icons';
import {
    faBell as solidFaBell,
    faPencil as solidFaPencil,
    faTrash as solidFaTrash,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ActionMenu } from 'components/menu/ActionMenu';
import { ActionMenuButton } from 'components/menu/ActionMenuButton';
import { ActionMenuItem } from 'components/menu/ActionMenuItem';
import { ActionMenuTableCell } from 'components/menu/ActionMenuTableCell';
import { usePopup } from 'custom_hooks/usePopup';
import { useThemeValues } from 'styles/theme';

export type SettingsActionMenuProps = {
    className?: string;
    onSettingsClick: () => void;
    onAcknowledgeAlertsClick?: () => void;
    onDeleteClick: () => void;
    canEdit?: boolean;
    canDelete?: boolean;
    renderContext?: 'table';
};
export function SettingsActionsMenu({
    className,
    onSettingsClick,
    onAcknowledgeAlertsClick,
    onDeleteClick,
    canEdit,
    canDelete,
    renderContext,
}: SettingsActionMenuProps) {
    const { isOpen, toggleOpen, close, triggerRef, popupRef } = usePopup();
    const { link, secondaryText, deleteButton } = useThemeValues();

    const hasMultipleActions = Boolean(onAcknowledgeAlertsClick) || Boolean(canDelete);
    const hasAnyAction = canEdit || hasMultipleActions;
    const isTableContext = renderContext === 'table';
    const showPencilOnly = isTableContext && canEdit && !hasMultipleActions;

    return (
        <ActionMenuTableCell className={className}>
            {showPencilOnly && (
                <ActionMenuButton
                    onClick={onSettingsClick}
                    ref={triggerRef}
                    // the table button wrappers will handle the 'active' border styling
                    borderless={isTableContext}
                    icon={faPencil}
                    aria-label="Edit Activity"
                />
            )}
            {!showPencilOnly && hasAnyAction && (
                <ActionMenuButton
                    onClick={toggleOpen}
                    ref={triggerRef}
                    // the table button wrappers will handle the 'active' border styling
                    borderless={isTableContext}
                />
            )}
            {isOpen && (
                <ActionMenu
                    onClose={close}
                    ref={popupRef}
                    buttonRef={triggerRef}
                    useOverlay
                >
                    {canEdit && (
                        <ActionMenuItem
                            title={isTableContext ? 'Edit Activity' : 'Settings'}
                            hoverIcon={
                                <FontAwesomeIcon icon={solidFaPencil} color={link} />
                            }
                            icon={
                                <FontAwesomeIcon icon={faPencil} color={secondaryText} />
                            }
                            onSelect={() => {
                                close();
                                onSettingsClick();
                            }}
                        />
                    )}
                    {onAcknowledgeAlertsClick && (
                        <ActionMenuItem
                            title={`Acknowledge Alert${
                                renderContext !== 'table' ? 's' : ''
                            }`}
                            hoverIcon={
                                <FontAwesomeIcon icon={solidFaBell} color={link} />
                            }
                            icon={<FontAwesomeIcon icon={faBell} color={secondaryText} />}
                            onSelect={() => {
                                close();
                                onAcknowledgeAlertsClick();
                            }}
                        />
                    )}
                    {canDelete && (
                        <ActionMenuItem
                            title="Delete"
                            hoverIcon={
                                <FontAwesomeIcon
                                    icon={solidFaTrash}
                                    color={deleteButton}
                                />
                            }
                            icon={
                                <FontAwesomeIcon icon={faTrash} color={secondaryText} />
                            }
                            onSelect={() => {
                                close();
                                onDeleteClick();
                            }}
                        />
                    )}
                </ActionMenu>
            )}
        </ActionMenuTableCell>
    );
}
